export default {
  basic: () => import("/vercel/path0/layouts/basic.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)
}